// extracted by mini-css-extract-plugin
export default {"wrapper":"zeroTaskSandbox_wrapper__XelZ5","imageUpload":"zeroTaskSandbox_imageUpload__ro3rm","options":"zeroTaskSandbox_options__OeihT"};